import { useMediaQuery } from './useMediaQuery';

export const MOBILE_BREAKPOINT = 876;

export const useIsMobile = () =>
  useMediaQuery(`(max-width: ${MOBILE_BREAKPOINT + 1}px)`, undefined, {
    // this needed to calculate proper initial value on first render, as opposed to a first useEffect call
    getInitialValueInEffect: false,
  });
